import { LicensesRepository, ActivationCodesRepository, DevicesRepository, AppIntegrationsRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import { DevicesProcessor } from 'common/repositoryProcessors/index';

/**
 * @ngdoc service
 * @name controllers.WelcomeModalSpotlight
 *
 * @description
 * Welcome Modal Spotlight
 */
angular.module('controllers')
    .controller(
        'WelcomeModalSpotlight',
        (
            $scope, $state, $document, LicenseRestService,
            Sso, ActivationCodeRestService, Util, DeployRestService,
        ) => {

            angular.element($document[0].body).addClass('splash-screen');

            // retrieve the x-a-* params and forward them to the backend
            const ssoParams = Sso.getParams();
            const metaParams = {};
            const currentDeviceOS = Util.getDeviceNavigator();

            Object.keys(ssoParams).forEach((key) => {

                if (key.indexOf('x-a-') > -1) {

                    metaParams[key] = ssoParams[key];

                }

            });

            $scope.product = AppIntegrationsRepository.getAppName('aps10');
            $scope.brandName = CWCONFIG.partnerConfig.name;
            $scope.license = LicensesRepository.getLicenseByAppId($state.params.resourceId);
            if (!$scope.license) {

                const licensePayload = {
                    data: {
                        relationships: {
                            app: {
                                data: {
                                    type: 'apps',
                                    id: $state.params.resourceId,
                                },
                            },
                        },
                    },
                    meta: {
                        'x-params': metaParams,
                    },
                };
                // add campgain param in meta
                if (metaParams['x-a-channel']) {

                    licensePayload.meta.cmp = metaParams['x-a-channel'];

                }
                LicenseRestService.create(licensePayload).then((license) => {

                    $scope.license = license;

                    // get activationCode after the license is received
                    ActivationCodeRestService.getAllAsync().then((response) => {

                        ActivationCodesRepository.replace(response.data.data);

                    });

                }).catch(() => {

                    $scope.closeModal();

                });

            }

            const mixpanelPayload = {
                Source: 'ws_spotlight',
                Modal: 'Spotlight Welcome Modal',
                Page: Util.getPageName(),
            };

            Mixpanel.send('ConnectWeb Modal Open ', mixpanelPayload);

            $scope.$on('$destroy', () => {

                angular.element($document[0].body).removeClass('splash-screen');

            });

            $scope.installApp = () => {

                const mixpanelData = {
                    Modal: 'Spotlight Welcome Modal',
                    'Button Label': 'Install now',
                    'Product ID': $state.params.resourceId,
                    Page: Util.getPageName(),
                };

                Mixpanel.send('ConnectWeb Modal Button Click', mixpanelData);

                const devices = DevicesRepository.getVisibleDevices();

                devices.forEach((device) => {

                    // if device has Windows OS
                    if (device.attributes.os === 'windows') {

                        const deploymentPayload = {
                            deviceId: device.id,
                            userId: Util.deepFind(device, 'relationships.user.data.id'),
                            appId: 'aps10',
                        };

                        DeployRestService
                            .deployOnDevice(deploymentPayload)
                            .then(() => {

                                /*  if there are only Windows devices redirect
                                    the user to Subscriptions page */
                                if (!devices.find(deviceItem => deviceItem.attributes.os !== 'windows')) {

                                    $state.go('root.dashboard.subscriptions', {
                                        tab: 'plans',
                                    });

                                }

                            })
                            .then(null, (e) => {

                                /* 409 === Conflict
                                An instance for this application already
                                exists (pending) - ignore */
                                if (e.status === 409) {

                                    return;

                                }

                                Alert.error({
                                    message: 'cw.modal.server-error.desc',
                                    icon: {

                                        cssClasses: `icon-${Util.deepFind(device, 'attributes.type')}`,

                                    },

                                });

                            });

                    }

                });

                /* if there are no devices or the current user OS
                    is not Windows show autoInstall modal */
                if (devices.length === 0 ||
                    devices.find(device => device.attributes.os !== 'windows')) {

                    const matchingOS = DevicesProcessor.getDeployOSfor('aps10', currentDeviceOS) || null;
                    const hasMatchingOS = !!matchingOS;

                    $scope.closeModal();

                    setTimeout(() => {

                        $state.go('root.dashboard.subscriptions.ltb.deploy', {
                            ltb: 'deploy',
                            deviceId: 'new',
                            resourceId: 'aps10',
                            appId: 'aps10',
                            os: matchingOS,
                            autoInstall: hasMatchingOS,
                        });

                    }, 400);

                }

            };

            $scope.closeModal = () => {

                $state.go('root.dashboard.subscriptions', {
                    tab: 'plans',
                });

            };

        },

    );



// WEBPACK FOOTER //
// ./scripts/controllers/modals/welcome-modal-spotlight/welcome-modal-spotlight.js